import { ActivityDisplayMessage } from '@/models/gen/graphql';
import { Dayts, getClasses } from '@/utils';
import { ListGroup, ListGroupItemProps } from 'react-bootstrap';

import { ReactElement } from 'react';

export type ActivityItemProps = ListGroupItemProps & {
  item: ActivityDisplayMessage;
};

const ActivityItem = ({ item, className, ...props }: ActivityItemProps): ReactElement => {
  return (
    <ListGroup.Item {...props} className={getClasses('ActivityItem', className)}>
      <div className="ActivityItem-Icon">
        <i className="sv sv-earth" />
      </div>
      <div className="ActivityItem-Info">
        <div className="ActivityItem-Date">
          <strong>{new Dayts(item.createdAt).format('MM/DD/YY - HH:mm:ss')}</strong>
        </div>
        <div className="ActivityItem-Message">{item.displayMessage}</div>
      </div>
    </ListGroup.Item>
  );
};

export default ActivityItem;
